import Link from 'admin/components/atoms/Link';
import { COLOR } from 'admin/constants/styles';
import React from 'react';
import styled from 'styled-components';

export type CrumbType = {
  value: string;
  href: string;
  isCurrentPage: boolean;
};

const CrumbWrapper = styled.ul`
  // TODO: should fix the .pb-content styling
  margin: -1rem -1rem 1rem -1rem;
  background: ${COLOR.superLightGray};
  padding: 0.5rem 1rem;
  color: ${COLOR.gray};
`;

const CrumbItem = styled.li`
  display: inline-block;
  list-style-type: none;
  &:not(:first-child)::before {
    content: '>';
    margin: 0 5px;
  }
`;

const buildItems = (crumbs: CrumbType[] | Crumb[] = []) => {
  return crumbs.map((c) => {
    const text = c.isCurrentPage ? c.value : <Link to={c.href}>{c.value}</Link>;
    return <CrumbItem key={`crumb-${c.value}`}>{text}</CrumbItem>;
  });
};

const BreadCrumb = ({
  crumbs,
  className,
}: {
  crumbs: CrumbType[] | Crumb[];
  className?: string;
}) => {
  const items = buildItems(crumbs);
  return <CrumbWrapper className={className}>{items}</CrumbWrapper>;
};

/**
 * @deprecated Crumb Class is deprecated. Use CrumbType instead.
 */
export class Crumb {
  value: string;

  href: string;

  isCurrentPage: boolean;

  constructor(value: string, href: string, isCurrentPage: boolean) {
    this.value = value;
    this.href = href;
    this.isCurrentPage = isCurrentPage;
  }
}
export default BreadCrumb;
